module.exports = __webpack_public_path__ + "images/bg-coupon-d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-coupon-d.png
// module id = 831
// module chunks = 121